import React, { useEffect, useState } from 'react';
import {  useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Modal, Table } from 'antd';
import { TIMELINE_DETAIL_TABLE_COLUMNS_TITLE } from '../../constants/crmConstants';
import { RootState } from '../../../store';
import { checkEmptyObj, getDefaultStr, isJson } from '../../../modules/crm/inPatient/service/crmUtils';
import Text from 'antd/lib/typography/Text';

const TimelineDetailModal = ( {match, isTimelineDetailModal, handleCancel}: any): any => {
  const [flowList, setFlowList] = useState([] as any);
  const details: any = useSelector((state: RootState): any => state?.admissionDetails?.claimDetails);
  const defaultTimeline = useSelector((state: RootState): any => state?.newAdmission?.defaultTimeline);

  const { params: { claimDetail } } = match;

  const getDesignedRemark = (remark: any): any => {
    if (checkEmptyObj(remark)) {
      return 'Initiating...';
    } else {
      return Object.keys(remark).filter((key: any): any => (remark[key]))
        .map((key: any, index: any): any => (
          <div key={index}>
            <Text type="secondary"><strong className="fsize_sm mb-0">{key}</strong></Text>
            <p className="fsize_sm mb-0" data-testid="test-remarks">{remark[key] || '-'}</p>
          </div>
        ));
    }
  };

  const getProperRemark = (remarks: any): any => {
    if (!remarks) {
      return (
        <p className="fsize_sm mb-0" data-testid="test-remarks">{getDefaultStr(remarks, true) || '-'}</p>
      );
    } else if (typeof (remarks) === 'string') {
      if (isJson(remarks)) {
        remarks = JSON.parse(remarks);
        return getDesignedRemark(remarks);
      } else {
        return (<p className="fsize_sm mb-0" data-testid="test-remarks">{getDefaultStr(remarks, true) || '-'}</p>);
      }
    } else if (typeof remarks === 'object' && !Array.isArray(remarks)) {
      return getDesignedRemark(remarks);
    } else {
      return (
        <p className="fsize_sm mb-0" data-testid="test-remarks">{getDefaultStr(remarks, true) || '-'}</p>
      );
    }
  };

  useEffect((): any => {
    if (details?.claimFlowData) {
      const { claimFlowData } = details;
      const localArr: any[] = claimFlowData.map(({
        status: title, remarks: remarks, createdDate: createdDate,
        procedureDesc: procedureDesc, procedureType: procedureType,
        claimedAmount: claimedAmount, approvedAmount: approvedAmount,
        submittedBy: submittedBy, doa: doa, dod: dod, statusId: statusId,
      }: any, index: any): any => ({
        title, remarks:  getProperRemark(remarks) , createdDate,
        procedureDesc, procedureType, claimedAmount, approvedAmount, submittedBy, doa, dod, key: index, statusId,
      }));
      setFlowList(localArr);
    }
  }, [details]);

  return (
    <div>
      <Modal
        visible={isTimelineDetailModal}
        onCancel={handleCancel}
        maskClosable={false}
        closable={true}
        width={1100}
        footer={null}
      >
        <Table dataSource={claimDetail ? flowList : [defaultTimeline]}  pagination={false} title={(): any => ' '}
        size={'small'} columns={TIMELINE_DETAIL_TABLE_COLUMNS_TITLE} scroll={{ x: 1300, y: 400  }} />
      </Modal>
    </div>
  );
};

export default withRouter(TimelineDetailModal);
